import { render } from "./TakEawaysushi.vue?vue&type=template&id=d5ada794"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawaysushi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5ada794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5ada794', __exports__)) {
    api.reload('d5ada794', __exports__)
  }
  
  module.hot.accept("./TakEawaysushi.vue?vue&type=template&id=d5ada794", () => {
    api.rerender('d5ada794', render)
  })

}


export default __exports__